import { createApiRequester } from './request'

export const usePublicApi = createApiRequester('public')
